export const OPTIMISTIC_OPERATION_KEY = 'optimistic-operation-id';
export const isOperationOptimistic = (operationId: string) => operationId.startsWith(OPTIMISTIC_OPERATION_KEY);

export const OPTIMISTIC_STEP_KEY = 'optimistic-step-id';
export const OPTIMISTIC_STEP_SEPARATING_KEY = 'optimistic-step-separating-id';
export const isStepSeparating = (stepId: string) => stepId.startsWith(OPTIMISTIC_STEP_SEPARATING_KEY);
export const isStepOptimistic = (stepId: string) => stepId.startsWith(OPTIMISTIC_STEP_KEY) || isStepSeparating(stepId);
